import { render, staticRenderFns } from "./Box11.vue?vue&type=template&id=423c7aa2&scoped=true&"
import script from "./Box11.vue?vue&type=script&lang=js&"
export * from "./Box11.vue?vue&type=script&lang=js&"
import style0 from "./Box11.vue?vue&type=style&index=0&id=423c7aa2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423c7aa2",
  null
  
)

export default component.exports